import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import { GET_PLAN_UTILITY_ACCOUNTS_QUERY } from './solar.api';
import * as States from './states';

export const Solar = () => {
  const { planId } = useParams<{ planId?: string }>();
  const { data, loading, error } = useQuery<
    GetPlanUtilityAccountsQuery,
    GetPlanUtilityAccountsQueryVariables
  >(GET_PLAN_UTILITY_ACCOUNTS_QUERY, {
    skip: !planId,
    variables: { planId: Number(planId) || -1 },
  });

  if (loading) return <LoadingPage />;
  if (error || !data) return <ErrorPage />;

  return data.plan.utilityAccounts.length > 0 ? (
    <States.WithUtilityAccounts />
  ) : (
    <States.WithoutUtilityAccounts />
  );
};
